import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NgModel } from '@angular/forms';

@Component({
    selector: 'mt-select-all',
    templateUrl: 'select-all.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectAllComponent implements OnInit {
  @Input() model: NgModel;
  @Input() values: any;
  @Input() text = 'Select All';
  @Output() onSelectAll = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  isChecked(): boolean {
    if (this.values && this.values['options']) {
      return (
        this.model.value &&
        this.values['options'].length &&
        this.model.value.length === this.values['options'].length
      );
    } else {
      return (
        this.model.value &&
        this.values.length &&
        this.model.value.length === this.values.length
      );
    }
  }

  isIndeterminate(): boolean {
    const options = this.values?.['options'] || this.values;
    return (
      this.model.value &&
      options &&
      options.length > 0 &&
      this.model.value.length > 0 &&
      this.model.value.length < options.length
    );
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      // for dynamic filters
      if (
        this.values &&
        this.values['options'] &&
        this.values['options'].length > 0
      ) {
        if (this.values && this.values['display']) {
          let dis = this.values['value'];
          this.model.update.emit(
            this.values['options'].map((each) => each[dis])
          );
        } else {
          this.model.update.emit(this.values['options'].map((each) => each));
        }
      }
      // static filters depends on the keys
      if (this.values && this.values.length > 0) {
        if (this.values[0].id) {
          this.model.update.emit(this.values.map((each) => each.id));
        } else if (this.values[0].name) {
          this.model.update.emit(this.values.map((each) => each.name));
        }
        if (this.values[0].branchId) {
          this.model.update.emit(this.values.map((each) => each.branchId));
        }
        if (this.values[0].BaseConfigId) {
          this.model.update.emit(this.values.map((each) => each.BaseConfigId));
        }
      }
      this.onSelectAll.emit(this.model);
    } else {
      this.model.update.emit([]);
      this.onSelectAll.emit();
    }
  }
}
